import {
  Video,
  PersonStanding,
  Wrench,
  MessageCircle,
  BookOpen,
  Settings,
  LogOut,
  Home,
  Users,
  Bell,
} from 'lucide-react';
import { FEATURES } from '../../config/features.js';

export const sidebarNavItems = [
  {
    label: 'Home',
    icon: Home,
    path: '/',
    match: (pathname) => pathname === '/',
  },
  {
    label: 'Yoga Sessions',
    icon: Video,
    path: '/videos',
    videoType: 'session',
    feature: 'videos',
    match: (pathname, state) =>
      pathname.startsWith('/videos') && state?.yocasType === 'session',
  },
  {
    label: 'Yoga Poses',
    icon: PersonStanding,
    path: '/videos',
    videoType: 'Pose',
    feature: 'videos',
    match: (pathname, state) =>
      pathname.startsWith('/videos') && state?.yocasType === 'Pose',
  },
  {
    label: 'Yoga Modifications',
    icon: Wrench,
    path: '/videos',
    videoType: 'modification',
    feature: 'videos',
    match: (pathname, state) =>
      pathname.startsWith('/videos') && state?.yocasType === 'modification',
  },
  {
    label: 'Chats',
    icon: MessageCircle,
    path: '/chats',
    feature: 'chat',
    match: (pathname) => pathname.startsWith('/chat') || pathname === '/chats',
  },
  {
    label: 'Friends',
    icon: Users,
    path: '/friends',
    feature: 'friends',
    match: (pathname) => pathname.startsWith('/friends'),
  },
  {
    label: 'Notifications',
    icon: Bell,
    path: '/notifications',
    feature: 'notifications',
    match: (pathname) => pathname.startsWith('/notifications'),
  },
  {
    label: 'Yoga Science',
    icon: BookOpen,
    path: '/manuals',
    feature: 'manuals',
    match: (pathname) => pathname.startsWith('/manuals'),
  },
];

export const sidebarFooterItems = [
  { label: 'Settings', icon: Settings, path: '/settings' },
  { label: 'Log Out', icon: LogOut, action: 'logout' },
];

export function isNavItemVisible(item) {
  if (item.feature) return FEATURES[item.feature];
  return true;
}
